import type { ViewRule } from '../models/ViewRules';

/** One enabled fill lens wins; preserve filter conditions and separate highlights/badges. */
export function resolveColorLensRules(rules: ViewRule[]): ViewRule[] {
  const winner = rules
    .filter((rule) => rule.enabled && (rule.display.heatmap || rule.display.colorByField))
    .sort((a, b) => b.order - a.order)[0];
  return rules.map((rule) => {
    if (rule === winner) return rule;
    if (!rule.display.heatmap && !rule.display.colorByField) return rule;
    const { heatmap: _heatmap, colorByField: _colorByField, ...display } = rule.display;
    return { ...rule, display };
  });
}
